import { apiSlice } from "../../../../app/service/Service";

export const useCardsSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        displayCards: builder.query({
            query : ()=> ({
                    url: `Ginrummy/CardDistributed`,
                    method: "GET",
                    
            })
        }),  
    })
})

export const { useDisplayCardsQuery } = apiSlice;
